// 资源相关的路由


const routes = [
  //智慧课堂
  {
    path: '/series',
    name: 'series',
    meta: {
      title: '精品课程',
      volcengine: true,
    },
    component: () => import('../pages/courses/series.vue')
  },
   //智慧账号登录进入精品课程有文件夹
   {
    path: '/seriesFoloder',
    name: 'seriesFoloder',
    meta: {
      title: '精品课程',
      volcengine: true,
      hasBack: false,
    },
    component: () => import('../pages/courses/serieszhihui/seriesFolder.vue')
  },
  //智慧账号登录进入精品课程
  {
    path: '/insideseries',
    name: 'insideseries',
    meta: {
      title: '精品课程',
      volcengine: true,
    },
    component: () => import('../pages/courses/serieszhihui/zhihuiCardList.vue')
  },
  // 智慧课堂创建课程系列
  {
    path: '/series/add',
    name: 'series/add',
    meta: {
      title: '添加课程系列'
    },
    component: () => import('../pages/courses/add/addSeries.vue')
  },
  // 智慧课堂创建课程系列
  {
    path: '/series/edit',
    name: 'series/edit',
    meta: {
      title: '修改课程系列'
    },
    component: () => import('../pages/courses/edit/editSeries.vue')
  },
  // 智慧课堂课程列表
  {
    path: '/series/list',
    name: 'series/list',
    meta: {
      title: "课程列表"
    },
    component: () => import('../pages/courses/courses.vue')
  },
  // 智慧课堂修改课程
  {
    path: '/course/edit',
    name: 'course/edit',
    meta: {
      title: '修改课程'
    },
    component: () => import('../pages/courses/edit/editCourses.vue')
  },
  // 智慧课堂课程制作课程大纲
  {
    path: '/outline/edit',
    name: 'outline/edit',
    meta: {
      title: '制作课程大纲'
    },
    component: () => import('../pages/courses/edit/editOutline.vue')
  },
  // 自制课程
  {
    path: '/selfCourses',
    name: 'selfCourseSeries',
    meta: {
      title: '自制课程'
    },
    component: () => import('../pages/courses/series.vue')
  },
  // 智慧课堂创建课程-选择教材
  {
    path: '/series/course/selectBooks',
    name: 'series/course/selectBooks',
    meta: {
      title: '选择课程内容'
    },
    component: () => import('../pages/courses/selectBooks.vue')
  },
  // 单词词书
  {
    path: '/wordBook',
    name: 'wordBook',
    meta: {
      title: '单词词书',
      volcengine: true,
    },
    component: () => import('../pages/wordBookV2/index.vue'),

  },
   // 校内词书
   {
    path: '/wordBookOnCampus',
    name: 'wordBookOnCampus',
    meta: {
      title: '校内词书',
      volcengine: true,
    },
    component: () => import('../pages/wordBookOnCampus/index.vue'),
  },
  // 智慧账号-单词词书
  {
    path: '/wordBook_zhihui',
    name: 'wordBook_zhihui',
    meta: {
      title: '单词词书',
      volcengine: true,
    },
    component: () => import('../pages/wordBook_zhihui/index.vue'),

  },
  // 词库管理-词库列表
  {
    path: '/ThesaurusList',
    name: 'ThesaurusList',
    meta: {
      title: '词库管理',
      volcengine: true,
    },
    component: () => import('../pages/thesaurus-list/ThesaurusList.vue'),
  },
  // 词书中心-汉字听写   
  {
    path: '/chineseDictation',
    name: 'chineseDictation',
    meta: {
      title: '汉字听写',
      volcengine: true,
    },
    component: () => import('../pages/chineseDictation/index.vue'),
  },
  // 合作方资源
  {
    path: '/contentTransfer',
    name: 'contentTransfer',
    meta: {
      title: '合作方资源',
      volcengine: true,
    },
    component: () => import('../pages/contentTransfer/index.vue'),
  },
  // 教材
  //学校教材区
  {
    path: '/schoolMaterialsArea',
    name: 'schoolMaterialsArea',
    meta: {
      title: '学校教材区',
      volcengine: true,
    },
    component: () => import('../pages/textbook/school/school.vue'),
  },
  // 班级文件夹下的教材列表
  {
    path: '/schoolMaterialsArea/detail',
    name: 'schoolMaterialsArea/detail',
    meta: {
      title: "学校教材区-详情"
    },
    component: () => import('../pages/textbook/school/detail.vue'),
    beforeEnter: (to, from, next) => {
      if (to.query.title) {
        to.meta.title = `学校教材区-${to.query.title}`
      }
      next()
    },
  },
  //阅读区教材
  {
    path: '/readMaterials',
    name: 'readMaterials',
    meta: {
      title: "阅读区教材",
      volcengine: true,
    },
    component: () => import('../pages/textbook/read/read.vue'),
  },
  //阅读区模块
  {
    path: '/readPlate',
    name: 'readPlate',
    meta: {
      title: "阅读区模块",
      volcengine: true,
    },
    component: () => import('../pages/textbook/readPlate/index.vue'),
  },
  //公立教材
  {
    path: '/publicMaterials',
    name: 'publicMaterials',
    meta: {
      title: "同步学教材",
      volcengine: true,
    },
    component: () => import('../pages/textbook/publicMaterials.vue'),
  },
  //班级教材
  {
    path: '/classMaterials',
    name: 'classMaterials',
    meta: {
      title: "班级教材",
      volcengine: true,
    },
    component: () => import('../pages/textbook/class/class.vue'),
  },
  // 班级教材列表
  {
    path: '/classMaterials/detail',
    name: 'classMaterials/detail',
    meta: {
      title: "班级教材-详情"
    },
    beforeEnter: (to, from, next) => {
      if (to.query.title) {
        to.meta.title = `班级教材-${to.query.title}`
      }
      next()
    },
    component: () => import('../pages/textbook/class/classDetail.vue'),
  },
  // 班级文件夹下的教材列表
  {
    path: '/classMaterials/folder/detail',
    name: 'classMaterials/folder/detail',
    meta: {
      title: "班级教材-详情"
    },
    beforeEnter: (to, from, next) => {
      if (to.query.title) {
        to.meta.title = `班级教材-${to.query.title}`
      }
      next()
    },
    component: () => import('../pages/textbook/class/classFolderDetail.vue'),
  },
  //自制教材
  {
    path: '/mineMaterials',
    name: 'textbookMine',
    meta: {
      title: "自制教材",
      volcengine: true,
    },
    component: () => import('../pages/textbook/mine/mine.vue'),
  },
  //自制教材-课文列表
  {
    path: '/mineMaterials/textList',
    name: 'mineMaterials/textList',
    meta: {
      title: "课文列表",
      volcengine: true,
    },
    component: () => import('../pages/pictureBook/list/index.vue'),
  },
  //自制文件夹教材详情
  {
    path: '/mineMaterials/mineDetail',
    name: 'textbookMine/mineDetail',
    meta: {
      title: "自制教材"
    },
    beforeEnter: (to, from, next) => {
      if (to.query.title) {
        to.meta.title = `自制教材-${to.query.title}`
      }
      next()
    },
    component: () => import('../pages/textbook/module/mineDetail.vue'),
  },
  // 内部账号-制作词书
  {
    path: '/mineMaterials/wordBook_textbook',
    name: 'mineMaterials/wordBook_textbook',
    meta: {
      title: '词书制作',
      volcengine: true,
    },
    component: () => import('../pages/wordBook_textbook/index.vue'),
  },
  // 习题
  //课文习题-课本
  {
    path: '/exercisesText',
    name: 'exercisesText',
    meta: {
      title: "课文习题-课本",
      volcengine: true,
    },
    // component: () => import('../pages/iframe/index.vue'),
    component: () => import('../pages/exercises/text/book.vue'),
  },
  //课文习题-课文
  {
    path: '/exercisesText/text',
    name: 'exercisesText/text',
    meta: {
      title: "编辑"
    },
    component: () => import('../pages/exercises/text/text.vue'),
  },
  //课文习题-课文-详情
  {
    path: '/exercisesText/textDetail',
    name: 'exercisesText/textDetail',
    meta: {
      title: "课文详情"
    },
    component: () => import('../pages/exercises/text/textDetail.vue'),
  },
    //录入习题
    {
      path: '/enterExercises',
      name: 'enterExercises',
      meta: {
        title: "录入习题",
        volcengine: true,
      },
      // component: () => import('../pages/iframe/index.vue'),
      component: () => import('../pages/exercises/enter.vue'),
    },
  // 试卷题目列表页
  {
    path: '/enterExercises/detail',
    name: 'enterExercises/detail',
    meta: {
      title: '试卷试题列表'
    },
    component: () => import('../pages/exercises/paperDetail.vue'),
  },
  //学校习题库
  {
    path: '/schoolExercises',
    name: 'schoolExercises',
    meta: {
      title: "学校习题库",
      volcengine: true,
    },
    component: () => import('../pages/exercises/school.vue'),
  },
  // 教材配套，专项练习
  {
    path: '/papers/:type',
    name: 'papers',
    meta: {
      title: "学校习题",
      volcengine: true, // 是否开启bm_pageview事件埋点
    },
    component: () => import('../pages/exercises/paper.vue'),
    beforeEnter: (to, from, next) => {
      if (to.params.type === 'textbook') {
        to.meta.title = '教材配套'
        next()
      } else if(to.params.type === 'special') {
        to.meta.title = '专项练习'
        next()
      }
      else {
        next('/papers/special')  //放行
      }
    }
  },
  //本校习题
  {
    path: '/ownExercises',
    name: 'ownExercises',
    meta: {
      title: "本校习题",
      volcengine: true,
    },
    component: () => import('../pages/exercises/ownSchool.vue'),
  },
  // 录入习题iframe
  {
    path: '/enteringQuestion',
    name: 'enteringQuestion',
    meta: {
      title: "录入习题",
      volcengine: true,
    },
    component: () => import('../pages/exercises/enteringQuestion.vue'),
  },
  // 机构习题制作
  {
    path: '/exercisemaking',
    name: 'exercisemaking',
    meta: {
      title: "习题制作",
      volcengine: true,
    },
    component: () => import('../pages/exercises/exerciseMaking.vue'),
  },
]

export default routes
